import React from "react";
import { Layout, Row, Col, Card, Button } from "antd";
import AppFooter from "../../components/sp-footer";
import aboutImg from "../../assets/about-image.png";
import BannerSection from "../../components/sp-banner";
import { useNavigate } from "react-router-dom";
import bannerImg from "../../assets/bannerr.jpg";


const { Content } = Layout;

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Content>
        {/* Banner Section */}
        <BannerSection />

        {/* About Us Section */}
        <div
          style={{
            position: "relative",
            backgroundColor: "#f4dba7e8",
            padding: "80px 10%",
            zIndex: 2,
          }}
        >
          <Row gutter={[40, 40]} align="middle">
            <Col xs={24} md={12}>
              <Card bordered={false} style={{ background: "transparent", boxShadow: "none" }}>
                <h2 style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "20px", color: "#222" }}>
                  About Us
                </h2>
                <p style={{ fontSize: "18px", lineHeight: "1.7", color: "#333" }}>
                  We provide fast and reliable shipment services to ensure your packages
                  reach their destination safely and on time. Our goal is to simplify
                  the shipping process and give you peace of mind.
                </p>
               
              </Card>
            </Col>
            
          </Row>
        </div>
      </Content>
      <AppFooter />
    </Layout>
  );
};

export default HomePage;
